import _ from "lodash";
import DebugLogger from "../../../../utils/DebugLogger";
import DynamicServiceHelper from "./DynamicServiceHelper";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import Constants from "../../../../../config/Constants";

const TAG = "RNSpeechRecognize Azure";

export default class AzureIATSpeechRecognitionService {
    TIMEOUT_SECONDS = 180;

    subscriptionKey = "";
    useProxy = false;
    proxyAddress = "";
    lang = "";

    //for now it is generate by java code, if we use this, we should generate token in the server side.
    token = null;
    expireTime = 0;

    streamSendingError = false;
    realTimeVoiceDataWriter = null;

    tmpReferenceText = null;
    tmpCallback = null;
    isRecording = false; // we will not throw exception/reject promise when recording for stream request

    constructor(configMap) {
        this.subscriptionKey = configMap.subscriptionKey;

        if (_.has(configMap, "region")) {
            this.region = configMap.region;
        }
        if (_.has(configMap, "useProxy")) {
            this.useProxy = configMap.useProxy;
        }
        if (_.has(configMap, "proxyAddress")) {
            this.proxyAddress = configMap.proxyAddress;
        }

        if (_.has(configMap, "lang")) {
            this.lang = configMap.lang;
        }
    }

    Recognize(referenceText, wav, callback) {
        //start request.

        DebugLogger.log(TAG, "ajax call start");
        const requestUrl = this.GenerateUrl(this.region);

        //initializeToken();
        const finalUrl = DynamicServiceHelper.GetUrl(requestUrl, 0, this.useProxy, this.proxyAddress);

        wav.arrayBuffer()
            .then(audioContent => {
                fetch(finalUrl, {
                    method: "POST",
                    processData: false,
                    contentType: false,
                    headers: {
                        "Ocp-Apim-Subscription-Key": this.subscriptionKey,
                        "Content-type": "audio/wav; codecs=audio/pcm; samplerate=16000",
                        Accept: "application/json",
                        "Content-Length": audioContent.length,
                        "Pronunciation-Assessment": this.GeneratePA(referenceText),
                    },
                    body: audioContent,
                })
                    .then(response => response.json())
                    .then(responseData => {
                        callback.onSuccess("", JSON.stringify(responseData));
                    })
                    .catch(err => {
                        DebugLogger.log("_postFileApi err", err);
                        callback.onFailure("Error", err.message);
                    });

                DebugLogger.log(TAG, "ajax call build end");
            })
            .catch(err => {
                DebugLogger.log("_postFileApi err", err);
                callback.onFailure("Error", err.message);
            });
    }

    BeforeSendVoiceData(referenceText, callback) {
        throw new Error("recognize with record is not supported");
    }

    SendVoiceData(voiceData, offset, length) {
        //if error in stream request, we just do not send anymore
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            try {
                this.realTimeVoiceDataWriter.write(voiceData, offset, length);
            } catch (ex) {
                this.streamSendingError = true;
                DebugLogger.log(TAG, "SendVoiceData Error:");
                DebugLogger.log(TAG, ex.message);
            }
        }
    }

    AfterSendVoiceData(wav) {
        this.isRecording = false;
        DebugLogger.log(TAG, "AfterSendVoiceData");
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            DebugLogger.log(TAG, "AfterSendVoiceData Normal Case");
            this.realTimeVoiceDataWriter.stop();
            this.realTimeVoiceDataWriter = null;
        } else {
            DebugLogger.log(TAG, "AfterSendVoiceData Bad Case");
            this.Recognize(this.tmpReferenceText, wav, this.tmpCallback);
        }
    }

    IsErrorWhenSendingStream() {
        return this.streamSendingError;
    }

    NeedSendWavHeaderInNetworkStream() {
        return true;
    }

    getIsSpeechEvaluation() {
        return true;
    }

    destroy() {
        //nothing to do
    }

    GeneratePA(referenceText) {
        return Base64.stringify(Utf8.parse(`{"ReferenceText":"${referenceText}","GradingSystem":"HundredMark","Dimension":"Comprehensive", "EnableMiscue": "True", "Granularity": "Phoneme"}`)).toString();
    }

    GenerateUrl() {
        const langCode = this.lang === Constants.SPEECH_LANG.en ? "en-US" : "zh-cn";
        return `https://${this.region}.stt.speech.microsoft.com/speech/recognition/conversation/cognitiveservices/v1?language=${langCode}&profanity=raw&format=detailed`;
    }
}
